import * as React from 'react';
import { observable } from 'mobx';
import { NotFoundPage } from '../../../mainv2/containers/common/NotFoundPage';
import { LoaderRow } from '../../components/atoms/layout/LoaderRow';
import { observer } from 'mobx-react';
import { PracticalSectionPageState } from './states/PracticalSectionPageState';
import { ExamPracticalSectionView } from '../../components/organisms/exam_sections/ExamPracticalSectionView';
import { withNavigation } from '../../components/hocs/withNavigation';
import { NavigationSpecs } from '../../states/NavigationState';
import './practicalSectionPage.module.scss';
import { authenticated } from '../../components/hocs/authenticated';

type Props = {
    match: {
        params: {
            sectionId: string;
        };
    };
};

@authenticated
@withNavigation(NavigationSpecs.home('mint-green'), NavigationSpecs.home('white', false))
@observer
export class PracticalSectionPage extends React.Component<Props> {
    @observable pageState = new PracticalSectionPageState();
    componentDidMount(): void {
        const sectionId = Number(this.props.match.params.sectionId);
        this.pageState.init(sectionId);
    }

    render() {
        const { section } = this.pageState;
        if (section.isNotFound()) {
            return <NotFoundPage entityType="課題" />;
        }
        return (
            <div>
                {section.loading && <LoaderRow />}
                {!section.isEmpty() && (
                    <div styleName="view-wrapper">
                        <ExamPracticalSectionView section={section.get()} />
                    </div>
                )}
            </div>
        );
    }
}
